export const data = {
    "quotes":[
      {
        "quote": "Three things cannot be long hidden: the sun, the moon, and the truth.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "An idea that is developed and put into action is more important than an idea that exists only as an idea.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "On life's journey, faith is nourishment, virtuous deeds are a shelter, wisdom is the light by day, and right mindfulness is the protection by night.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Do not be a judge of others; be a judge of yourself.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "To keep the body in good health is a duty... otherwise, we shall not be able to keep the mind strong and clear.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "The root of suffering is attachment.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Just as a flower does not pick and choose the bees that come to it, so the Buddha does not discriminate against those who come to him seeking the Dharma.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "In the sky, there is no distinction of east and west; people create distinctions out of their own minds and then believe them to be true.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "A man is not called wise because he talks and talks again; but if he is peaceful, loving, and fearless, then he is in truth called wise.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Holding on to anger is like grasping a hot coal with the intent of throwing it at someone else; you are the one who gets burned.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Better than a thousand hollow words is one word that brings peace.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Health is the greatest gift, contentment the greatest wealth, faithfulness the best relationship.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "The secret of health for both mind and body is not to mourn for the past, not to worry about the future, but to live the present moment wisely and earnestly.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "The only real failure in life is not to be true to the best one knows.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "The way is not in the sky. The way is in the heart.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "It is better to conquer yourself than to win a thousand battles. Then the victory is yours. It cannot be taken from you.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Your work is to discover your work and then, with all your heart, to give yourself to it.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Our life is shaped by our mind; we become what we think.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Doubt everything. Find your own light.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "The mind is everything. What you think you become.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Peace comes from within. Do not seek it without.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "A jug fills drop by drop.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Radiate boundless love towards the entire world.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "The tongue like a sharp knife... Kills without drawing blood.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "In separateness lies the world's great misery, in compassion lies the world's true strength.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Work out your own salvation. Do not depend on others.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "A disciplined mind brings happiness.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "A wise man, recognizing that the world is but an illusion, does not act as if it is real, so he escapes the suffering.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "One moment can change a day, one day can change a life, and one life can change the world.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Your body is precious. It is our vehicle for awakening. Treat it with care.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "You will not be punished for your anger; you will be punished by your anger.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "The way to gain a good reputation is to endeavor to be what you desire to appear.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "To understand everything is to forgive everything.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "An insincere and evil friend is more to be feared than a wild beast; a wild beast may wound your body, but an evil friend will wound your mind.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "What we think, we become.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "The trouble is, you think you have time.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "We are what we think. All that we are arises with our thoughts. With our thoughts, we make the world.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "To live a pure unselfish life, one must count nothing as one's own in the midst of abundance.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Conquer anger by love, evil by good; conquer the miser with liberality, and the liar with truth.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "There are only two mistakes one can make along the road to truth; not going all the way, and not starting.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Purity or impurity depends on oneself. No one can purify another.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Better than a thousand hollow words, is one word that brings peace.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "The mind is everything. What you think you become.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "In the end, only three things matter: how much you loved, how gently you lived, and how gracefully you let go of things not meant for you.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "You only lose what you cling to.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "The less you respond to negative people, the more peaceful your life will become.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Happiness does not depend on what you have or who you are. It solely relies on what you think.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Hatred does not cease by hatred, but only by love; this is the eternal rule.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Do not dwell in the past, do not dream of the future, concentrate the mind on the present moment.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "The only real failure in life is not to be true to the best one knows.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "It is better to travel well than to arrive.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "To understand everything is to forgive everything.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Let yourself be open and life will be easier. A spoon of salt in a glass of water makes the water undrinkable. A spoon of salt in a lake is almost unnoticed.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "To be idle is a short road to death and to be diligent is a way of life; foolish people are idle, wise people are diligent.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "No one saves us but ourselves. No one can and no one may. We ourselves must walk the path.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Silence the angry man with love. Silence the ill-natured man with kindness. Silence the miser with generosity. Silence the liar with truth.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "An idea that is developed and put into action is more important than an idea that exists only as an idea.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "It is a man's own mind, not his enemy or foe, that lures him to evil ways.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "The past is already gone, the future is not yet here. There's only one moment for you to live.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "The root of suffering is attachment.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "You will not be punished for your anger; you will be punished by your anger.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Radiate boundless love towards the entire world.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Teach this triple truth to all: A generous heart, kind speech, and a life of service and compassion are the things which renew humanity.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "The trouble is, you think you have time.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Health is the greatest gift, contentment the greatest wealth, faithfulness the best relationship.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "You only lose what you cling to.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "The only real failure in life is not to be true to the best one knows.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "We are shaped by our thoughts; we become what we think. When the mind is pure, joy follows like a shadow that never leaves.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "There is no path to happiness: happiness is the path.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "You yourself, as much as anybody in the entire universe, deserve your love and affection.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "A jug fills drop by drop.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Every morning we are born again. What we do today matters most.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "The mind is everything. What you think you become.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "To understand everything is to forgive everything.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "The greatest prayer is patience.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Your work is to discover your work and then, with all your heart, to give yourself to it.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "The wise are controlled in bodily action, controlled in speech and controlled in thought. They are truly well-controlled.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Let a man guard himself against irritability in speech; let him be controlled in speech. Abandoning verbal misconduct, let him practice good conduct in speech.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Overcome the angry by non-anger; overcome the wicked by goodness; overcome the miser by generosity; overcome the liar by truth.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Those sages who are inoffensive and ever restrained in body, go to the Deathless State, where, having gone, they grieve no more.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Those who are ever vigilant, who discipline themselves day and night, and are ever intent upon Nibbana — their defilements fade away.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "One by one, little by little, moment by moment, a wise man should remove his own impurities, as a smith removes his dross from silver.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Just as rust arising from iron eats away the base from which it arises, even so, their own deeds lead transgressors to states of woe.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Easy is life for the shameless one who is impudent as a crow, is backbiting and forward, arrogant and corrupt.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Difficult is life for the modest one who always seeks purity, is detached and unassuming, clean in life, and discerning.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "One who destroys life, utters lies, takes what is not given, goes to another man's wife, and is addicted to intoxicating drinks — such a man digs up his own root even in this world.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Know this, O good man: evil things are difficult to control. Let not greed and wickedness drag you to protracted misery.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "There is no fire like lust; there is no grip like hatred; there is no net like delusion; there is no river like craving.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "If anything is to be done, let one do it with sustained vigor. A lax monastic life stirs up the dust of passions all the more.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "An evil deed is better left undone, for such a deed torments one afterwards. But a good deed is better done, doing which one repents not later.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Happy indeed we live, friendly amidst the hostile. Amidst hostile men we dwell free from hatred.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Happy indeed we live, friendly amidst the afflicted (by craving). Amidst afflicted men we dwell free from affliction",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Happy indeed we live, free from avarice amidst the avaricious. Amidst the avaricious men we dwell free from avarice.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Happy indeed we live, we who possess nothing. Feeders on joy we shall be, like the Radiant Gods.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "There is no fire like lust and no crime like hatred. There is no ill like the aggregates (of existence) and no bliss higher than the peace (of Nibbana).",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Hunger is the worst disease, conditioned things the worst suffering. Knowing this as it really is, the wise realize Nibbana, the highest bliss.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Health is the most precious gain and contentment the greatest wealth. A trustworthy person is the best kinsman, Nibbana the highest bliss.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Having savored the taste of solitude and peace (of Nibbana), pain-free and stainless he becomes, drinking deep the taste of the bliss of the Truth.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Good is it to see the Noble Ones; to live with them is ever blissful. One will always be happy by not encountering fools.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Calm is his thought, calm his speech, and calm his deed, who, truly knowing, is wholly freed, perfectly tranquil and wise.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Inspiring, indeed, is that place where Arahants dwell, be it a village, a forest, a vale, or a hill.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "Inspiring are the forests in which worldlings find no pleasure. There the passionless will rejoice, for they seek no sensual pleasures.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "The fever of passion exists not for him who has completed the journey, who is sorrowless and wholly set free, and has broken all ties.",
        "author": "Shakyamuni Buddha"
      },
      {
        "quote": "It doesn't matter how bad we are, a bodhisattva still sees us as beings with Buddha-nature.",
        "author": "Venerable Xianzhong Shi"
      },
      {
        "quote": "No one can help everyone, but everyone can help someone.",
        "author": "Venerable Xianzhong Shi"
      },
      {
        "quote": "Giving is the most direct way to grow compassion, and every giving can increase love and kindness in the heart and make people more compassionate.",
        "author": "Venerable Xianzhong Shi"
      },
      {
        "quote": "A bodhisattva is someone who recognizes his oneness with all life everywhere.",
        "author": "Master Hsing Yun"
      },
      {
        "quote": "A bodhisattva must be patient because the work of liberating sentient beings will take a long time.",
        "author": "Master Hsing Yun"
      },
      {
        "quote": "All sentient beings have the Tathagata's wisdom and virtue, but they fail to realize it because they cling to deluded thoughts and attachments.",
        "author": "Master Hsing Yun"
      },
      {
        "quote": "A smile is the most beautiful colour in the world.",
        "author": "Master Hsing Yun"
      }
    ],
  }
